// extracted by mini-css-extract-plugin
export default {"loading":"styles_loading__Zw4pH","icon":"styles_icon__zR1WP","spin":"styles_spin__3MFQz"};